import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import logoImage from '../assets/img/logoreal.png';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative overflow-hidden text-stone-100" style={{ backgroundColor: '#2E2318' }}>
      {/* Liseré doré en haut */}
      <div className="h-px w-full" style={{ background: 'linear-gradient(90deg, transparent, rgba(217,166,65,0.6), transparent)' }} />

      <div className="max-w-6xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 items-start">

          {/* Marque */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <img
              src={logoImage}
              alt="Au Coing du Ventoux"
              width={96}
              height={96}
              className="w-24 h-24 rounded-full bg-white p-1 shadow-md"
            />
            <p className="font-sans mt-5 text-lg tracking-wide" style={{ color: '#F0EADF' }}>
              Au Coing du Ventoux
            </p>
            <p className="font-nunito text-sm mt-1" style={{ color: 'rgba(240,234,223,0.6)' }}>
              Soleu &amp; Destre
            </p>
          </div>

          {/* Contact */}
          <div className="text-center md:text-left">
            <h3 className="font-sans text-xs tracking-[0.3em] uppercase mb-5" style={{ color: '#D9A641' }}>
              Contact
            </h3>
            <ul className="font-nunito space-y-2" style={{ color: 'rgba(240,234,223,0.85)' }}>
              <li>SARL Soleu &amp; Destre</li>
              <li>84340 Vaucluse, France</li>
              <li>
                <a href="mailto:contact@aucoingduventoux.com" className="transition-colors hover:text-white" style={{ color: 'inherit' }}>
                  contact@aucoingduventoux.com
                </a>
              </li>
            </ul>
          </div>

          {/* Informations */}
          <div className="text-center md:text-left">
            <h3 className="font-sans text-xs tracking-[0.3em] uppercase mb-5" style={{ color: '#D9A641' }}>
              Informations
            </h3>
            <ul className="font-nunito space-y-2">
              <li>
                <Link to="/politique-de-confidentialite" className="transition-colors hover:text-white" style={{ color: 'rgba(240,234,223,0.85)' }}>
                  {t('footer.links.privacy_policy')}
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="transition-colors hover:text-white" style={{ color: 'rgba(240,234,223,0.85)' }}>
                  {t('footer.links.legal_mentions')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Message de modération */}
        <p className="font-nunito text-center italic mt-14 max-w-2xl mx-auto" style={{ color: 'rgba(240,234,223,0.7)' }}>
          {t('footer.message')}
        </p>
      </div>

      {/* Bas de page */}
      <div className="border-t" style={{ borderColor: 'rgba(217,166,65,0.18)' }}>
        <div className="max-w-6xl mx-auto px-8 py-6 text-center">
          <p className="font-nunito text-xs leading-relaxed" style={{ color: 'rgba(240,234,223,0.55)' }}>
            {t('footer.copyright')}
          </p>
          <p className="font-nunito text-xs mt-1" style={{ color: 'rgba(240,234,223,0.4)' }}>
            {t('footer.designed_by')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;